import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-more\"><defs><style type=\"text/css\"></style></defs><path d=\"M12.8 190.8l998.4 0 0 102.4-996.4 0 0-102.4Z\" p-id=\"5416\" /><path d=\"M12.8 700.2l998.4 0 0 102.4-698.88 0 0-102.4Z\" p-id=\"5417\" /><path d=\"M12.8 448.512l998.4 0 0 102.4-436.864 0 0-102.4Z\" p-id=\"5418\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/more.svg
// module id = gZ6Q
// module chunks = 102